<template>
    <div>
        <configurator v-if="!loading" :start-step="4"></configurator>
    </div>
</template>

<script>
    import Configurator from "@/components/Configurator";
    import axios from 'axios'

    export default {
        name: "Edit",
        components: {Configurator},
        data() {
            return {
                loading: true
            }
        },
        mounted() {
            this.loading = true
            axios.all([this.$http.get('/orders/' + this.$route.params.id + '/edit'), this.$store.dispatch('prepareMaterials')])
                .then(axios.spread((order) => {
                    this.$store.commit('setEditData', order.data)
                    this.loading = false
                }))
            this.$store.dispatch('setActualCurrencies');
        }
    }
</script>

<style scoped>

</style>
